import React from 'react';
import { StyledDiv } from '../styled-elements';
import EnterpriseCustomers from '../customers/enterprise/EnterpriseCustomers';
import OrdersTable from '../orders/OrdersTable';
import OrdersNotifications from './OrdersNotifications';

import { TabList, TabPanel, TabPanelProps } from '@mui/lab';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import EnterpriseNotifications from './EnterpriseNotifications';
import { isUserAuthenticated , hideOptions } from "../../utils/config";

function NotificationList() {



    const [value, setValue] = React.useState(0);
  
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);

        
      };



  return (
    <div className="App border">
   
   

   <Tabs value={value} onChange={handleChange} >
      <Tab label="Orders" sx={{textTransform :"none"}}/>
     {!hideOptions() &&  <Tab label="Enterprise Accounts" sx={{textTransform :"none"}}  /> }
   
    </Tabs>

    <div >
       
     { (value == 0) &&  <OrdersNotifications></OrdersNotifications> }
    </div>

    { !hideOptions() &&  <div >
    { (value == 1 ) &&  <EnterpriseNotifications></EnterpriseNotifications> }
    </div>
     } 

   
   
  </div>
  );
}

export default NotificationList;
